import angular from 'angular';
import template from './modals.html';
import './modals.scss';
import itemComponent from './item/item';
import modalService from './modals.service';
class ModalsController {
    constructor(modalsService) {
        this.modalsService = modalsService;
    }
    $onInit() { }
}
const modals = {
    template,
    controller: ModalsController,
};
export default angular
    .module('doxy.common.components.modals.modals', [itemComponent, modalService])
    // modals
    .component('modals', modals).name;
